import { useEffect, useState } from "react";
import { getConsentImplementation } from "@rome2rio/tcf-api";

/**
 * A hook that updates with which privacy regulations are applicable for the given user
 *
 * @returns A list of applicable privacy regulations to the user, or `undefined` if not yet known
 */
export function useApplicablePrivacyRegs() {
  // Try setting the value early - to placate tests that HATE state being updated 1 microsecond after rendering in a promise.
  const [applicableRegulations, setApplicableRegulations] = useState<
    string[] | undefined
  >(import.meta.env.MODE === "test" ? [] : undefined);

  // TODO: If we end up causing too many calls to addEventListener, we could make this into a context
  useEffect(() => {
    getConsentImplementation().then(
      (consentImplementation) => {
        let filteredConsents = consentImplementation;
        setApplicableRegulations(filteredConsents);
      },
      () => {
        setApplicableRegulations(undefined);
      },
    );
  }, []);

  return applicableRegulations;
}
